import * as React from 'react';

var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Plus_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 6.125h-5.25V.875a.875.875 0 00-1.75 0v5.25H.875a.875.875 0 000 1.75h5.25v5.25a.875.875 0 101.75 0v-5.25h5.25a.875.875 0 100-1.75z",
    fill: "#D1D1D1",
    stroke: "#D1D1D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Plus_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
}

export { SvgPlus as ReactComponent };
//# sourceMappingURL=Plus.svg.js.map
